"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("reflect-metadata");

var _reactIntl = require("react-intl");

var _reactRouterDom = require("react-router-dom");

var _styledComponents = require("styled-components");

var _reactHelmetAsync = require("react-helmet-async");

var _hops = require("@xingternal/hops");

var _Notification = require("@xingternal/winery-ui/lib/Notification");

var _AppContext = _interopRequireDefault(require("@contexts/AppContext"));

var _withSelectedLanguage = require("@infrastructure/i18n/withSelectedLanguage");

var _App = require("./src/App");

var _helpers = require("./src/helpers");

var _mediaQueries = require("@infrastructure/styling/mediaQueries");

var _withFeatureFlags = require("@infrastructure/permission/withFeatureFlags/withFeatureFlags");

var _PDFContext = require("@contexts/PDFContext");

var _routes = require("./src/routes");

var _router = require("./src_new/infrastructure/routing/router");

var _ErrorBoundary = require("./src_new/infrastructure/errorHandling/ErrorBoundary/ErrorBoundary");

var _rebrandingAdapter = require("@xingternal/rebranding-adapter");

var _i18n = require("@infrastructure/i18n");

var _onlyfy_Product_Icon_Black_Brand_Icon = _interopRequireDefault(require("@ui/core/assets/onlyfy_Product_Icon_Black_Brand_Icon.ico"));

var _onlyfy_Product_Icon_White_Brand_Icon = _interopRequireDefault(require("@ui/core/assets/onlyfy_Product_Icon_White_Brand_Icon.ico"));

var _faviconXing = _interopRequireDefault(require("@ui/core/assets/favicon-xing.ico"));

var _browserTheme = require("@infrastructure/styling/browserTheme");

var _app = require("@config/app.constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const wineryTheme = (0, _rebrandingAdapter.createTheme)();
const Login = (0, _hops.importComponent)({
  load: () => import(
  /* webpackChunkName: 'dNUF' */
  "./src/routes/Login"),
  moduleId: require.resolveWeak("./src/routes/Login"),
  chunkName: () => "dNUF"
});
const cookieConsentURL = (0, _helpers.isProduction)() ? 'https://static.xingcdn.com/userconsent/cookie-consent-min.js' : 'https://preview-static.xingcdn.com/userconsent/cookie-consent-min.js';
const AppContextProvider = (0, _withSelectedLanguage.withSelectedLanguage)((0, _withFeatureFlags.withFeatures)(_AppContext.default));
const PreFlightChecks = (0, _withFeatureFlags.withFeatures)((0, _reactIntl.injectIntl)((0, _hops.withServerData)(({
  serverData: {
    authenticated,
    language
  },
  intl,
  featureSwitches
}) => {
  const isXingRebrandingEnabled = featureSwitches === null || featureSwitches === void 0 ? void 0 : featureSwitches.includes(_app.FEATURE_SWITCHES.XING_REBRANDING_ENABLED);
  const rebranding = {
    enableXingRebranding: isXingRebrandingEnabled
  };
  const {
    mode
  } = (0, _browserTheme.useThemeMode)();
  const theme = { ...wineryTheme(rebranding),
    ...(isXingRebrandingEnabled ? {
      colors: { ..._rebrandingAdapter.xingTheme.colors,
        lightPetrol: _rebrandingAdapter.xingTheme.colors.primaryText,
        petrol: _rebrandingAdapter.xingTheme.colors.primaryText,
        linkText: _rebrandingAdapter.xingTheme.colors.primaryText,
        accent: _rebrandingAdapter.xingTheme.colors.primaryText,
        borderActive: _rebrandingAdapter.xingTheme.colors.primaryText
      },
      borders: { ..._rebrandingAdapter.xingTheme.borders,
        active: `1px solid ${_rebrandingAdapter.xingTheme.colors.primaryText}`
      }
    } : {})
  };
  return /*#__PURE__*/_react.default.createElement(_rebrandingAdapter.RebrandingProvider, {
    featureFlags: rebranding
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_mediaQueries.MediaQueryProvider, null, /*#__PURE__*/_react.default.createElement(_rebrandingAdapter.GlobalStyles, null), /*#__PURE__*/_react.default.createElement(_ErrorBoundary.ErrorBoundary, null, (0, _helpers.isDevelopment)() || authenticated ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Notification.Notifications, null), /*#__PURE__*/_react.default.createElement(AppContextProvider, {
    language: language
  }, /*#__PURE__*/_react.default.createElement(_PDFContext.PDFProvider, null, /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, (0, _i18n.translateAppName)(language, isXingRebrandingEnabled)), /*#__PURE__*/_react.default.createElement("script", {
    src: cookieConsentURL,
    defer: true
  }), /*#__PURE__*/_react.default.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1"
  }), isXingRebrandingEnabled ? /*#__PURE__*/_react.default.createElement("link", {
    rel: "icon",
    "data-testid": "favicon-test",
    href: _faviconXing.default
  }) : /*#__PURE__*/_react.default.createElement("link", {
    rel: "icon",
    "data-testid": "favicon-test",
    href: mode === _browserTheme.LIGHT_MODE ? _onlyfy_Product_Icon_Black_Brand_Icon.default : _onlyfy_Product_Icon_White_Brand_Icon.default
  })), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_App.App, {
    router: [..._routes.router, ..._router.nextRouter]
  }))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.Helmet, null, /*#__PURE__*/_react.default.createElement("title", null, (0, _i18n.translateAppName)(language), " Login"), /*#__PURE__*/_react.default.createElement("script", {
    src: cookieConsentURL,
    defer: true
  }), isXingRebrandingEnabled ? /*#__PURE__*/_react.default.createElement("link", {
    rel: "icon",
    "data-testid": "favicon-test",
    href: _faviconXing.default
  }) : /*#__PURE__*/_react.default.createElement("link", {
    rel: "icon",
    "data-testid": "favicon-test",
    href: mode === _browserTheme.LIGHT_MODE ? _onlyfy_Product_Icon_Black_Brand_Icon.default : _onlyfy_Product_Icon_White_Brand_Icon.default
  })), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: _helpers.routes.login,
    component: Login
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: _helpers.routes.login
  })))))));
})));

var _default = (0, _hops.render)( /*#__PURE__*/_react.default.createElement(PreFlightChecks, null));

exports.default = _default;